
    import "src/shared/components/UploadBulkPreview/index.module.scss?farm_css_modules";
    
    export default {"bulkPreviewPage": `bulkPreviewPage-66ee4d18`,"cancelButton": `cancelButton-66ee4d18`,"header": `header-66ee4d18`}
    